import { useNavigate } from "react-router-dom";
import { formPath, navigationState } from "@/core/routing/navigationPolicy";

export function useAppNavigation() {
  const navigate = useNavigate();
  return {
    goToHome: () => navigate("/", { state: navigationState("start") }),
    goBack: () => navigate(-1),
    goToFormCreate: (businessId: string) =>
      navigate(`${formPath(businessId)}/new`, { state: navigationState("push") }),
    goToFormDetails: (businessId: string, formId: string, finish = false) =>
      navigate(formPath(businessId, formId), { replace: finish, state: navigationState(finish ? "finish" : "push") }),
    goToFormEdit: (businessId: string, formId: string) =>
      navigate(`${formPath(businessId, formId)}/edit`, { state: navigationState("push") }),
  };
}
